import * as React from "react";
import { TextInput } from "components";
import { BodyContext } from "../tbody/duck";

interface TableTextInputProps {
  defaultValue: string;
  onBlur(newValue: string): Promise<any> | void;
}

const TableTextInput: React.FC<TableTextInputProps> = ({
  defaultValue,
  onBlur
}) => {
  const { setEditable, setPending } = React.useContext(BodyContext);

  return (
    <TextInput
      defaultValue={defaultValue}
      onBlur={event => {
        const newValue = event.target.value;
        if (defaultValue !== newValue) {
          setPending(true);
          const blurResult = onBlur(newValue);
          if (blurResult) {
            blurResult.then(() => {
              setEditable(false);
              setPending(false);
            });
          } else {
            setEditable(false);
            setPending(false);
          }
        } else {
          setEditable(false);
        }
      }}
      h="100%"
      borderRadius="0"
      autoFocus
      fontSize="sm"
      px="23px"
      inputLayoutProps={{
        height: "100%"
      }}
      inputGroupProps={{
        height: "100%"
      }}
    />
  );
};

export default TableTextInput;
